import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { StudyArea } from '../../interfaces/study-area';
import { ConfirmationService } from 'primeng/api';
import { Store } from '@ngxs/store';
import { UpdateStudyAreaAccess } from 'src/app/state/study-area/study-area.actions';
import { StudyAreaAccess } from '../../enums/study-area-access';
import { PredictorModelActions } from 'src/app/state/predictor-model/predictor-model.actions';
import { UserState } from 'src/app/state/user/user.state';
import { ToggleDfpspecialistModalComponent } from '../toggle-dfpspecialist-modal/toggle-dfpspecialist-modal.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StudyAreaAccessService } from '../../services/study-area-access.service';
import { DfpSpecialistRequest } from '../../interfaces/dfpspecialist';
import { NotificationsActions } from 'src/app/state/notifications/notifications.actions';
import { Severity } from 'src/app/global/enums/severity';

@Component({
  selector: 'app-study-area-list-item',
  templateUrl: './study-area-list-item.component.html',
  styleUrls: ['./study-area-list-item.component.scss']
})
export class StudyAreaListItemComponent implements OnInit, OnChanges {
  @Input() studyArea: StudyArea | null = null;
  @Output() accessChanged = new EventEmitter<any>(); // Define event
  checked: boolean = false; // used to track the checked state of the input switch
  dfpSpecialistRoleAccess: boolean = false; // used to track if the user is an area admin
  shareStudyAreaFetureEnabled: boolean = false; // used to track if the share study area feature is enabled
  statusText: string = StudyAreaAccess.Private; // used to display the status text based on the checked state
  isAbleToShareStudyArea: boolean = false; // used to track if the user can share the study area
  isAbleToEditDfpSpecialist: boolean = false; // used to track if the user can edit the dfp specialist

  constructor(
        private readonly store: Store,
        private readonly confirmationService: ConfirmationService,
        private readonly studyAreaService: StudyAreaAccessService,
       private readonly dialogService: DialogService  ) {}
 ngOnInit()
 {
   let userProfile = this.store.selectSnapshot(UserState.userProfile);
    this.dfpSpecialistRoleAccess = this.store.selectSnapshot(UserState.dfpSpecialistRoleAccess)
    
    if (  this.studyArea?.emailAddress?.toLowerCase() === userProfile.email?.toLowerCase() ||
          this.studyArea?.dfpSpecialistEmail?.toLowerCase() === userProfile.email?.toLowerCase())
    {
      this.isAbleToShareStudyArea = true;
    }
    if(this.studyArea?.emailAddress === userProfile.email)
    {
      this.isAbleToEditDfpSpecialist = true;
    }
    
    
     if(this.studyArea?.emailAddress === userProfile.email)
     {
      this.statusText = this.checked ? StudyAreaAccess.Shared : StudyAreaAccess.Private;
     }
     else{
       this.statusText = this.checked ? StudyAreaAccess.Revoke : StudyAreaAccess.Private;
     }
 }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['studyArea']) {
      const currentStudyArea: any = changes['studyArea'].currentValue;
      this.checked = currentStudyArea?.shared === true;
      this.statusText = this.checked ? StudyAreaAccess.Shared : StudyAreaAccess.Private;
      console.log('yourInput changed:', this.checked);
    }
  }

  onToggleChange(studyArea: any): void {

    if (this.checked === true) {
     this.openDFPSpecialistModal('add',studyArea);
    }
    else {
      
       this.confirmationService.confirm({
        header: `Restrict Access`,
        message: `Turning this off will immediately revoke access to this study area. People will lose the ability to view, edit, or share it. You can re‑enable sharing at any time. Are you sure you want to continue?`,
        accept: () => {

      let request = {} as DfpSpecialistRequest;   
      request.studyAreaId =  studyArea.id ;   
      this.accessChanged.emit(StudyAreaAccess.Private);
      request.isShared = false;
      studyArea.shared = false;
      
     this.studyAreaService
               .updateDfpSpecialists(request)
               .subscribe({
                 next: (updatedLicense) => {             
                   this.store.dispatch(
                     new NotificationsActions.Toast(
                        'Access to study area revoked from DFP Specialist.',
                       Severity.Success
                     )
                   );
                   this.GetStudyAreaList();
                 },
                 error: (err) => {
                   console.error('Error updating license:', err);
                   this.store.dispatch(
                     new NotificationsActions.Toast(
                        'Failed to revoke access to study area from DFP Specialist. Please try again.',
                       Severity.Error
                     )
                   );
                 },
               });
        },
        reject: () => {
          console.info('Revoke Study Area access Canceled');
        },
        acceptIcon: '.',
        rejectIcon: '.',
        rejectButtonStyleClass: 'p-button-text',
        acceptButtonStyleClass:
          'basin-color-red-text-links p-button-text basin-ml-5',
        acceptLabel: 'Confirm',
        rejectLabel: 'Cancel',
      });

    }
  }

    openDFPSpecialistModal(
      modalMode: 'add' | 'edit',
      studyArea?: any,
    ): void {
      const ref: DynamicDialogRef = this.dialogService.open(
        ToggleDfpspecialistModalComponent,
        {
          width: '600px',       
          dismissableMask: false,
          closable: true,
          styleClass: 'bottom-rounded basin-font-primary ',
          header:'Share Access',
          data: {
            mode: modalMode,
            studyArea            
          },
        }
      );
       
  
      ref.onClose.subscribe((updatedLicense: any) => {
      
      });
    }

     ChangeDfpSpecialist(studyArea: any): void {

    if (this.checked === true) {
     this.openDFPSpecialistModal('edit',studyArea);
    }
  }

  onDivKeyDown(event: KeyboardEvent) {
 console.log(event);
}

// added below method to get latest study area list after sharing
GetStudyAreaList()
{
  this.store.dispatch(new PredictorModelActions.GetStudyAreas());  
}
}
